<template>
    <div class="question-container">

        <div class="toolbar pt-16 pb-16">
            <div class="back-container">
                <!--<span class="back" @click="backClick"></span>-->
            </div>
            <span class="title">LET’S GET STARTED</span>
            <div class="right-menu"></div>
        </div>


        <div class="mt-65">
            <div v-for="item in questionList" :key="item.id">
                <QuestionContent v-model="item.problemAnswer" :question="item"/>
            </div>
        </div>

        <div class="place-holder"></div>

        <Page class="mt-64 page-background"
              v-on:pageChanged="pageChanged"
              :total-item="totalItem" :page-size="pageSize" :current-page="currentPage"/>

        <div class="submit-answer-container" v-show="currentPage === pageSize">
            <div @click="submitAnswer" class="mt-36 submit-answer " block round type="primary">Save Profile
            </div>
        </div>
    </div>


</template>

<script>
    import userRepository from "../repository/store/UserRepository"
    import storeRepository from "../repository/store/StoreRepository"
    import QuestionContent from "./QuestionContent"
    import Page from "./Page"
    import {toast} from "../util/util"

    export default {
        name      : "Questions",
        components: {QuestionContent, Page},
        data() {
            return {
                questionList: [],
                allData     : [],
                pageSize    : 0,
                totalItem   : 0,
                currentPage : 1,
                groupList   : [],
                pageItem    : 3
            }
        },

        methods: {
            backClick() {

            },
            pageChanged(changed) {
                this.currentPage += changed
                this.questionList = this.groupList[this.currentPage - 1]
            },

            submitAnswer() {
                let checkAllSelected = true

                let submitData = []
                for (let i = 0; i < this.groupList.length; i++) {
                    for (let j = 0; j < this.groupList[i].length; j++) {
                        if (!this.groupList[i][j].problemAnswer) {
                            checkAllSelected = false
                            toast('Please complete all questions')
                            return
                        }

                        submitData.push({
                            id           : this.groupList[i][j].id,
                            problemAnswer: `${this.groupList[i][j].problemAnswer}`
                        })
                    }
                }

                userRepository.saveAnswer(submitData)
                    .then(data => {
                        return userRepository.userProfile()
                    })
                    .then(data => {
                        data.isReply = 1
                        storeRepository.saveUser(data)
                        this.$router.push('Pair')
                    })
            }
        },

        mounted() {
            userRepository.questionList().then(data => {
                this.totalItem = data.length
                this.allData   = data

                let pageSize = parseInt(this.totalItem / this.pageItem)
                const idle   = this.totalItem % this.pageItem
                if (idle !== 0) {
                    pageSize += 1
                }
                this.pageSize = pageSize

                let groupList = []
                for (let i = 0; i < pageSize; i++) {
                    if (idle !== 0 && i === pageSize - 1) {
                        groupList.push(data.slice(i * this.pageItem, i * this.pageItem + idle))
                    } else {
                        groupList.push(data.slice(i * this.pageItem, i * this.pageItem + this.pageItem))
                    }
                }
                this.groupList = groupList
                if (groupList.length > 0) {
                    this.questionList = groupList[this.currentPage - 1]
                }
            })
        }
    }
</script>

<style lang="scss" scoped>
    .question-container {
        flex-direction: column;
        justify-content: center;
        align-items: center;
        justify-items: center;

        .place-holder {
            flex: 1;
        }
    }

    .page-background {
        justify-content: center;
    }

    .submit-answer-container {
        display: flex;
        flex-direction: column;
        align-items: center;

        .submit-answer {
            background-color: #F6F6F6;
            border-radius: 16px;
            text-align: center;
            width: 300px;
            margin: 48px 48px;
            padding: 10px;
        }
    }
</style>